<div class="flex flex-col gap-2">
  @if (label()) {
    <label class="truncate" [ngClass]="smallLabel() ? 'text-sm' : ''" [for]="id()">
      {{ label() | transloco }}
      @if (isMandatory()) {
        <span class="text-red" [ngClass]="smallLabel() ? 'text-sm' : ''">*</span>
      }
    </label>
  }

  @if (isReadOnly()) {
    <input
      pInputText
      [value]="selectedOptionTranslations() | translateDirectus"
      [disabled]="true"
      class="w-full readOnly"
    />
  } @else {
    <p-selectButton
      [id]="id()"
      [attr.data-testid]="id() + '-input'"
      [formControlName]="fieldName()"
      [options]="options()"
      optionValue="id"
      [required]="isMandatory()"
      [unselectable]="true"
      class="w-full"
    >
      <ng-template #item let-item>
        {{ item.translations | translateDirectus }}
        @if (item.tooltip?.key) {
          <app-directus-tooltip
            tooltipStyleClass="tooltip-bg-second-level"
            [tooltipKey]="item.tooltip?.key"
          ></app-directus-tooltip>
        }
      </ng-template>
    </p-selectButton>
  }
</div>
